import { logger } from 'common/services';

import type Keycloak from 'keycloak-js';

const MIN_VALIDITY = 60;

export const updateKeycloakToken = async (keycloak: Keycloak) => {
  try {
    await keycloak.updateToken(MIN_VALIDITY);
  } catch (error) {
    if (error instanceof Error) {
      logger.error('[KC] Failed to refresh the token, or the session has expired', error);
    }
    await keycloak.logout();
  }
};

/**
 * The Keycloak login session the current tokens belong to. It stays the same across check-sso
 * refreshes and page reloads, and changes on every new login - so it identifies "this login".
 */
export const getKeycloakSessionState = (
  keycloak: Pick<Keycloak, 'idTokenParsed' | 'tokenParsed' | 'sessionId'>
): string | undefined =>
  (keycloak.idTokenParsed as { session_state?: string } | undefined)?.session_state ??
  (keycloak.tokenParsed as { session_state?: string } | undefined)?.session_state ??
  keycloak.sessionId;
